module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/8WAS6g/tc-custom/9781684371389_cover.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Rewind\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In this fast-paced time-travel thriller starring a compelling female character, Alex’s power as a spinner—a teen who can rewind time to help solve crimes—is suddenly in question."), _c('br'), _c('br'), _vm._v(" At sixteen, the dreaded time sickness that causes all spinners to die early strikes Alex. If she can’t be restabilized, she’ll live out the rest of her short life at the Center, where spinners are confined from birth, doing menial chores rather than completing missions with her partner, Agent Ross. When she’s offered an experimental treatment, Alex sees a future for herself for the first time. But the medication offers more than a promise—it also brings dire consequences. What if she lives longer but loses her mind? A strong heroine, Alex propels this high-stakes suspense novel to a thrilling conclusion that begs for a sequel. Readers will eagerly await book two in the planned trilogy."), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Carolyn O'Doherty\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Carolyn O'Doherty received her MFA from Stonecoast at the University of Southern Maine. She lives in Portland, Oregon, with her husband and two teenage sons. This is her debut novel.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Highlights Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf309572","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0